export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]*$/;
export const NAME_REGEX = /^[a-zA-Z0-9 ,.'_-]+$/i;
export const EMAIL_REGEX = /^[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const PHONE_NUMBER_REGEX =
  /^(\+?\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
export const PASSWORD_REGEX =
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^*()_+=|;:,.?-])(?!.*[><\'"\\[\\]&])(?!.*\\s).{8,}$';
export const DIVISION_ID_REGEX = /^[a-zA-Z0-9 _]*$/;
export const TEAM_ID_REGEX = /^(?!0$)[a-zA-Z0-9 _]*$/;

export const ZIPCODE_REGEX = /^\d{5}(-\d{4})?$/; // For USA

//Custom phone regex, upload file may contain values like 123-456-7890, 123.456.7890, 123 456 7890, (123) 456 7890, ext. 1234567890, 123-456-7890
export const CUSTOM_PHONE_NUMBER_REGEX = /^(?=.*\d)[A-Za-z-+ /.()\d]+$/i;

export const IP_V4_REGEX =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const IP_V6_REGEX = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/;

export const URL_REGEX =
  /^(https?:\/\/)([a-zA-Z0-9.-]+)(:\d+)?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/i;
